module.exports = __webpack_public_path__ + "img/paralax-content-mobile.725ab58.jpg";